// PartnerContext.tsx
import { createContext, useContext, useState, useEffect } from "react";
import { useGetCategoryPartnerActive } from "#/requests/get-category-partner-active";
import { ContentItem } from "#/api/partnersShowcase/partnersShowcase";

type typePartner = "SISTEMICO" | "LOCAL";

interface ICategoryPartnerContext {
  categoryPartners: any;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  setPartnerType: (typePartner: typePartner) => void;
  partnerType: typePartner;
  uf: string;
  setUf: (uf: string) => void;
  city: string;
  setCity: (city: string) => void;
  size: number;
  setSize: (size: number) => void;
}

const CategoryPartnerContext = createContext<ICategoryPartnerContext>(
  {} as ICategoryPartnerContext
);

export const CategoryPartnerProvider = ({ children }: any) => {
  const [categoryPartners, setCategoryPartner] = useState<
    ContentItem[] | undefined
  >([]);
  const [uf, setUf] = useState("");
  const [city, setCity] = useState("");
  const [size, setSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [partnerType, setPartnerType] = useState("" as typePartner);
  const activeCategory = useGetCategoryPartnerActive({
    typePartner: "SISTEMICO",
    page: currentPage - 1,
    city: city || undefined,
    size: size,
  });

  useEffect(() => {
    if (activeCategory.data) {
      setCategoryPartner(activeCategory?.data?.content);
    }
  }, [activeCategory.data]);

  return (
    <CategoryPartnerContext.Provider
      value={{
        categoryPartners,
        setCurrentPage,
        currentPage,
        setPartnerType,
        partnerType,
        uf,
        setUf,
        city,
        setCity,
        size,
        setSize,
      }}
    >
      {children}
    </CategoryPartnerContext.Provider>
  );
};

export const useCategoryPartnerContext = () =>
  useContext(CategoryPartnerContext);
